import * as React from "react";
import { useLocation } from "react-router-dom";
import { AppRoute } from "../../../../navigation/routes";
import IntakeQueue from "../IntakeQueue/IntakeQueue";
import ClientStatusView from "../ClientStatusView/ClientStatusView";
import BookedClientsList from "../BookedClientsList/BookedClientsList";
import ClientMasterListWrapper from "../ClientMasterListWrapper/ClientMasterListWrapper";

export default function ClientsWrapper() {
    const location = useLocation();

    if (location.pathname.endsWith(AppRoute.WAITLIST)) {
        return <div>Waitlist</div>;
    } else if (location.pathname.endsWith(AppRoute.BOOKED_CLIENTS)) {
        return <BookedClientsList />;
    } else if (location.pathname.endsWith(AppRoute.CLIENT_MASTER_LIST)) {
        return <ClientMasterListWrapper />;
    } else if (location.pathname.endsWith(AppRoute.INTAKE_QUEUE)) {
        return <IntakeQueue />;
    } else {
        return <ClientStatusView />;
    }
}
